import { EnrollmentPackageId, PersonId } from '../types/api/primaryKeys/PrimaryKey';
import { Nullable } from '../types/custom/Nullable';
import { userService } from './UserService';

interface PublicSession {
    enrollmentPackageId: EnrollmentPackageId;
    employeePersonId: PersonId;
    publicKey: string;
}

const publicSessionKey = 'wt-public-enrollment-last-session';

class PublicEnrollmentSessionService {
    private _publicSession: Nullable<PublicSession> = null;

    public tryRestorePublicSession(): boolean {
        const previousSession = sessionStorage.getItem(publicSessionKey);

        if (previousSession === null) {
            return false;
        }

        this._initializeSession(JSON.parse(previousSession) as PublicSession);
        return true;
    }

    /**
     * If you are calling this, you are probably wrong. Only one code spot will ever call this.
     * @param enrollmentPackageId 
     * @param sessionKey 
     */
    public _initializeSession(newPublicSession: PublicSession) {
        userService._initializeFromKnownPersonIdString(`${newPublicSession.employeePersonId}`);

        this._publicSession = newPublicSession;

        sessionStorage.setItem(publicSessionKey, JSON.stringify(newPublicSession));
    }

    public getPublicSession(): Nullable<Readonly<PublicSession>> {
        return this._publicSession;
    }

    public isPublicEnrollmentSessionActive() {
        return this._publicSession !== null;
    }
}

export const publicEnrollmentSessionService = new PublicEnrollmentSessionService();